<template>
    <div>
        <mainone :mainonebread="mainonebread"></mainone>
        <div>
            <!--标题-->
            <div class="box" style="">
                <div class="box_title" style="">
                    <div class="box_title_font">查看抽奖活动</div>
                    <div class="box_title_button">
                        <!--可添加按钮-->
                        <!--<el-button type="primary" class="max_search" @click="exportDatas(mainthreetableData)">导出数据</el-button>-->
                    </div>
                </div>
                <!--内容-->

                <div class="box_content">
                    <div class="box_title_font">基本信息</div>
                    <el-row style="margin-top: 20px">
                        <!--占位符-->
                        <el-col :span="24" :xs="24" :sm="24" :lg="6">
                            <div style="width: 100%"></div>
                        </el-col>
                        <!--主表样式-->
                        <el-col :span="24" :xs="24" :sm="24" :lg="10">
                            <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="160px"
                                class="demo-ruleForm">
                                <el-form-item label="活动名称：" prop="name">
                                    <el-input v-model="ruleForm.title" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="开始时间：">
                                    <el-input v-model="ruleForm.begin_time" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="到期时间：">
                                    <el-input v-model="ruleForm.end_time" :disabled="true"></el-input>
                                </el-form-item>
                                <el-form-item label="显示位置：" prop="positionname">
                                    <el-select v-model="ruleForm.positionname" placeholder="请选择" style="width: 100%"
                                        :disabled="true">
                                        <el-option :label="gettypeid" :value="index"
                                            v-for="(gettypeid, index) in mytyppid" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="活动类型：">
                                    <el-radio-group>
                                        <el-radio disabled v-if="ruleForm.consume_type == -1">无限制抽奖</el-radio>
                                        <el-radio disabled v-if="ruleForm.consume_type == 1">京币抽奖，消耗 <el-input
                                                v-model="ruleForm.consume_num" :disabled="true" style="width: 60px">
                                            </el-input>京币</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="参与次数：">
                                    <el-radio-group>
                                        <el-radio disabled>每人每天限抽<el-input v-model="ruleForm.times" :disabled="true"
                                                style="width: 60px"></el-input>次</el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <el-form-item label="奖品设置：">
                                    <!--<el-button-->
                                    <!--type="primary"-->
                                    <!--@click="add(dialogVisible = true)"-->
                                    <!--&gt;添加奖品-->
                                    <!--</el-button>-->
                                </el-form-item>

                                <el-form-item>
                                    <el-table :data="tableData" border style="width: 100%">
                                        <el-table-column prop="name" label="名称">
                                        </el-table-column>
                                        <el-table-column prop="typename" label="奖品">
                                        </el-table-column>
                                        <el-table-column prop="total_num" label="数量">
                                        </el-table-column>
                                        <el-table-column prop="yi" label="已发放">
                                        </el-table-column>
                                        <el-table-column prop="weight" label="中奖概率">
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <!--占位符-->
                        <el-col :span="24" :xs="24" :sm="24" :lg="8">
                            <div style="width: 100%"></div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mainone from "@/components/Mainone";
// import mainimgesup from "@/components/Mainimgesup.vue";
import { ref } from "vue";
import { ElMessage } from "element-plus";
import axios from "axios";

export default {
    name: "vluckydrawinfo",
    data() {
        return {
            tableData: [],
            mainonebread: [
                {
                    name: '运营',

                },
                {
                    name: '营销玩法',

                },
                {
                    name: '幸运大抽奖',
                    path: '/luckydraw'
                },
                {
                    name: '抽奖活动详情',
                    // path: '/luckydraw'
                }
            ], // 当前页-【面包屑导航】
            mytyppid: [], //广告位-配置
            mywebview: [], //webview跳转链接-配置
            mywechat: [], //H5/公众号跳转链接-配置
            myouter: [], //小程序APPID-配置
            ruleForm: {
                name: "",
                type_id: "",
                image: 376,
                status: ref("1"),
                jump_way: ref("1"),
                cishu: ref("1"),
                mini_path: "",
                wechat_path: "",
                outer_path: "",
                outer_url: "",
                begin_time: "",
                end_time: "",
                my_begin_time: "",
                my_end_time: "",
                sort: "",
                platform: [],
            }, //form表单
            rules: {
                name: [
                    {
                        required: true,
                        message: "广告名称为必填项",
                        trigger: "blur",
                    },
                ],
                type_id: [
                    {
                        required: true,
                        message: "请选择广告位置",
                        trigger: "change",
                    },
                ],
                image: [
                    {
                        required: true,
                        message: "请上传广告图片",
                        trigger: "change",
                    },
                ],
            }, //form表单-必填规则
            loading: false,
            mypowerlimits: JSON.parse(localStorage.getItem("powerlimits")), //获取权限
            mytoken: localStorage.getItem("token"), //获取存储的token
        };
    },
    created() {
        if (localStorage.getItem("token") === null || !localStorage.getItem("token")) {
            this.isshow = false;
            this.$router.push("/").catch((error) => error);
        } else {
            // window.addEventListener('resize', this.getwindowinfo); // 注册监听器-实时检测浏览器页面宽高
            // this.getwindowinfo()

            //加载loading
            this.loading = true      //通过Ajax向后台获取数据

            axios
                .post(
                    "/admin/config/info",
                    {
                        key_name: "lucky_draw_position",
                    },
                    {
                        headers: {
                            Authentication: localStorage.getItem("token"),
                        },
                    }
                )
                .then((response) => {
                    this.mytyppid = response.data.result;
                    //通过Ajax向后台获取数据
                    axios.post('/admin/luckyDraw/info',
                        {
                            id: this.$route.query.id,
                            // page:1,
                            // page_size:20
                        },
                        {
                            headers: {
                                'Authentication': this.mytoken
                            }
                        })
                        .then(response => {
                            // this.myaxiosfunc(response.data.result)
                            console.log(response.data.result)
                            this.ruleForm = response.data.result.draw;
                            var infos = response.data.result.draw.position;
                            this.ruleForm.begin_time = this.$utils.formatDate(response.data.result.draw.begin_time);
                            this.ruleForm.end_time = this.$utils.formatDate(response.data.result.draw.end_time);
                            this.ruleForm.positionname = this.mytyppid[infos];
                            // this.tableData = response.data.result.item;
                            this.change(response.data.result.item)
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                })
                .catch(function (error) {
                    console.log(error);
                });



        }
    },
    mounted() { },
    methods: {
        change(successdata) {
            var newdata = successdata
            for (var i = 0; i < newdata.length; i++) {
                //已发放
                newdata[i].yi = (newdata[i].total_num - 0) - (newdata[i].remain_num - 0)
                var types = newdata[i].type;
                if (types == 1) {
                    newdata[i].typename = "京币"
                } else if (types == 2) {
                    newdata[i].typename = "聚邻社优惠券"
                } else if (types == 3) {
                    newdata[i].typename = "印工厂优惠券"
                } else if (types == 4) {
                    newdata[i].typename = "省省团"
                } else if (types == 5) {
                    newdata[i].typename = "实物"
                }
            }
            this.tableData = newdata;
        },
        add() {
            this.dialogVisible = ref(true); //关闭弹窗
        },
        //点击关闭-弹窗
        handleCloseSenior(done) {
            done();
        },
        //选择时间并转换
        changeTimes(data, chart) {
            console.log("当前获取的时间：" + data);
            this.ruleForm[chart] = new Date(data).getTime();

            //比较开始时间与结束时间
            if (this.ruleForm.begin_time == "") {
                ElMessage({
                    type: "warning",
                    message: "请先选择开始时间！",
                });
                this.ruleForm.end_time = "";
            } else {
                if (this.ruleForm.end_time != "") {
                    if (this.ruleForm.begin_time > this.ruleForm.end_time) {
                        ElMessage({
                            type: "warning",
                            message: "选择的结束时间必须大于开始时间！",
                        });
                        this.ruleForm.end_time = "";
                    }
                }
            }
        },
        //获取upload子组件回传的数据
        getUploadFileEvent(data) {
            console.log("当前获取的回传数据：" + JSON.stringify(data));
            this.ruleForm.image = data.id;
        },
        //提交form表单-并判断是否必填
        submitForm(formName) {
            var formdatas = this.$refs[formName].model;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var datas = null;
                    if (formdatas.begin_time == 0) {
                        formdatas.begin_time = "";
                        formdatas.my_begin_time = "";
                    } else {
                        formdatas.my_begin_time = formdatas.begin_time / 1000;
                    }
                    if (formdatas.end_time == 0) {
                        formdatas.end_time = "";
                        formdatas.my_end_time = "";
                    } else {
                        formdatas.my_end_time = formdatas.end_time / 1000;
                    }
                    console.log("提交的form表单：" + JSON.stringify(formdatas));

                    datas = {
                        name: formdatas.name,
                        type_id: formdatas.type_id,
                        image: formdatas.image,
                        status: formdatas.status,
                        jump_way: formdatas.jump_way,
                        mini_path: formdatas.mini_path,
                        wechat_path: formdatas.wechat_path,
                        outer_path: formdatas.outer_path,
                        outer_url: formdatas.outer_url,
                        begin_time: formdatas.my_begin_time,
                        end_time: formdatas.my_end_time,
                        sort: formdatas.sort,
                        platform: formdatas.platform,
                    };
                    this.subDatas(datas);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        //重置form表单中填写的数据
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //提交API-函数
        subDatas(datas) {
            axios
                .post("/admin/advert/create", datas, {
                    headers: {
                        Authentication: localStorage.getItem("token"),
                    },
                })
                .then((response) => {
                    if (response.data.code === 0) {
                        ElMessage({
                            type: "success",
                            message: "提交成功！",
                            duration: 1000,
                            onClose: () => {
                                this.$router.push("/appletadvert").catch((error) => error);
                            },
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
    components: {
        mainone,
        // mainimgesup,
    },
};
</script>

<style scoped>
.box {
    background-color: #ffffff;
    border-radius: 4px;
    color: #333333;
    padding: 10px 20px;
}

.box_title {
    line-height: 40px;
    height: 40px;
}

.box_title_font {
    float: left;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
}

.box_title_button {
    float: right;
    font-weight: 400;
    font-size: 14px;
    color: #94a3d2;
}

.box_title_button:hover {
    cursor: pointer;
}

.box_content {
    border-top: 1px solid #eeeeee;
    margin-top: 10px;
}
</style>